<template>
    <div>
        <md-button class="md-primary pull-right header-button" @click="updateShipment" :disabled="!teamMembers.length">
            Edit
        </md-button>
    </div>
</template>

<script>
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { CUSTOMER_DETAILS_DEFAULTS } from '@/utils/defaults';
import CreateCustomerModal from '@/pages/Customer/Modals/CreateCustomerModal';
import UpdateShipmentModal from './UpdateShipmentModal';

export default {
    name: 'UpdateShipment',
    mixins: [GeneralMixin],
    props: {
        teamMembers: {
            type: Array,
            default: () => []
        },
        data: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            shipmentDetails: {}
        };
    },
    methods: {
        async handleCreateCustomer() {
            const customerDetails = { ...CUSTOMER_DETAILS_DEFAULTS(), teamRegionId: this.user.teamRegionId || null };
            const result = await this.$modal.showWithoutAutoClose(CreateCustomerModal, {
                customerDetails,
                version: 'v2'
            });
            if (result.status !== 'ok') {
                return;
            }
            const { customerId } = result.result;
            this.updateShipment({
                customerId
            });
        },
        updateShipment({ customerId }) {
            this.shipmentDetails = Object.assign({}, this.data);

            this.$modal
                .show(UpdateShipmentModal, {
                    members: this.teamMembers,
                    shipment: this.shipmentDetails,
                    overrideShipmentDetails: customerId ? { customerId } : null,
                    createCustomer: this.handleCreateCustomer
                })
                .then((response) => {
                    if (response.toLowerCase() === 'ok') 
                        this.emitShipmentUpdated();
                    this.$modal.hide();
                });
        },
        emitShipmentUpdated() {
            this.$emit('shipmentUpdated');
        }
    }
};
</script>

<style lang="scss" scoped>
.custom-btn {
    margin-right: 16px;
}
</style>
